const truthyValues = new Set(['1', 'true', 'yes', 'on']);

function readBooleanFlag(value: string | undefined, defaultValue = false) {
  if (!value) {
    return defaultValue;
  }

  return truthyValues.has(value.trim().toLowerCase());
}

export const featureFlags = {
  marketingOnly: readBooleanFlag(process.env.NEXT_PUBLIC_FEATURE_MARKETING_ONLY, false),
  guestPreview: readBooleanFlag(process.env.NEXT_PUBLIC_FEATURE_GUEST_PREVIEW_ENABLED, false),
  socialOAuth: readBooleanFlag(
    process.env.NEXT_PUBLIC_FEATURE_SOCIAL_OAUTH_ENABLED,
    process.env.NODE_ENV === 'development'
  ),
  authEdtechProviders: readBooleanFlag(process.env.NEXT_PUBLIC_FEATURE_AUTH_EDTECH_PROVIDERS, false),
  navbarCreate: readBooleanFlag(process.env.NEXT_PUBLIC_FEATURE_NAVBAR_CREATE, false),
  navbarBrainstorm: readBooleanFlag(process.env.NEXT_PUBLIC_FEATURE_NAVBAR_BRAINSTORM, false),
  navbarPortfolio: readBooleanFlag(process.env.NEXT_PUBLIC_FEATURE_NAVBAR_PORTFOLIO, false),
  navbarDashboard: readBooleanFlag(process.env.NEXT_PUBLIC_FEATURE_NAVBAR_DASHBOARD, false),
  viewContentStrategy: readBooleanFlag(process.env.NEXT_PUBLIC_FEATURE_VIEW_CONTENT_STRATEGY, false),
  footerExpandedLinks: readBooleanFlag(process.env.NEXT_PUBLIC_FEATURE_FOOTER_EXPANDED_LINKS, false),
};

export function isSocialOAuthEnabled() {
  return readBooleanFlag(
    process.env.NEXT_PUBLIC_FEATURE_SOCIAL_OAUTH_ENABLED,
    process.env.NODE_ENV === 'development'
  )
}
